import { Component, OnInit, Input, Inject } from '@angular/core';
import { WizardService } from '../../../../services/wizard/wizard.service';
import { ClipboardService } from 'common-lib/services';

@Component({
    selector: 'wizard-class-completion',
    templateUrl: './class-completion.component.html',
    styleUrls: ['./class-completion.component.scss']
})
export class ClassCompletionComponent implements OnInit {
    @Input() isUpdating = false;
    public schedulingLink = '';
    public classTitle = '';

    constructor(
        private wizardService: WizardService,
        @Inject(ClipboardService) private clipboardService: ClipboardService
    ) {}

    ngOnInit(): void {
        this.schedulingLink = this.wizardService.responseData.schedulingLink;
        this.classTitle = this.wizardService.options.subject;
    }

    handleCopyLink(link: string) {
        this.clipboardService.copyText(link);
    }
}
